import { render } from "./MsInput.vue?vue&type=template&id=47a54d30&scoped=true"
import script from "./MsInput.vue?vue&type=script&lang=js"
export * from "./MsInput.vue?vue&type=script&lang=js"

import "./MsInput.vue?vue&type=style&index=0&id=47a54d30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a54d30"]])

export default __exports__